import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function getReassignationReasons(company_id) {
  const response = await axios.get(`${LEADS_ENDPOINT}/reassignationReasons`,
    { params: { company_id } }
  )

  const formattedReasons = response?.data?.data.map(r => ({
    label: r,
    value: r,
  }))

  return formattedReasons
}
